(() => {
  const config = window.HEX_CUSTOM_CURSOR || {};
  const unsafePathPattern = /\/(cart|checkout|account|customers|login|register|addresses|wholesale)(\/|$)/i;
  const unsafeTemplateNames = new Set(['cart', 'customers/login', 'customers/register', 'customers/account', 'customers/addresses']);
  const interactiveSelector = [
    'a[href]',
    'button:not([disabled])',
    'summary',
    'label',
    '[role="button"]',
    '[data-product-card]',
    '[data-hex-product-card]',
    '.hex-highlight-link',
    'input[type="checkbox"]',
    'input[type="radio"]',
  ].join(',');
  const nativeSelector = [
    'input:not([type="checkbox"]):not([type="radio"])',
    'textarea',
    'select',
    '[contenteditable]',
    '[data-hex-cursor-native]',
    '.shopify-payment-button',
  ].join(',');

  let cursor = null;
  let rafId = null;
  let x = 0;
  let y = 0;
  let targetX = 0;
  let targetY = 0;
  let hasPointer = false;
  const cursorLerp = 0.28;

  const isEnabledByConfig = () => config.enabled === true;

  const hasFinePointer = () => (
    window.matchMedia('(hover: hover) and (pointer: fine)').matches
    && !window.matchMedia('(pointer: coarse)').matches
  );

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isUnsafeTemplate = () => {
    const templateName = String(config.templateName || '').toLowerCase();
    const templateSuffix = String(config.templateSuffix || '').toLowerCase();
    const pageType = String(config.pageType || '').toLowerCase();

    return unsafeTemplateNames.has(templateName)
      || templateSuffix === 'wholesale'
      || templateName.includes('customers')
      || pageType.includes('customers');
  };

  const isSafePage = () => (
    isEnabledByConfig()
    && !prefersReducedMotion()
    && hasFinePointer()
    && !unsafePathPattern.test(window.location.pathname)
    && !isUnsafeTemplate()
  );

  const closestEnabled = (target, selector) => {
    const element = target instanceof Element ? target : null;
    if (!element) return null;
    const match = element.closest(selector);
    if (!match) return null;
    if (match.matches('[disabled], [aria-disabled="true"], .disabled')) return null;
    return match;
  };

  const setStateFromTarget = (target) => {
    if (!cursor) return;

    const useNative = Boolean(closestEnabled(target, nativeSelector));
    const isInteractive = !useNative && Boolean(closestEnabled(target, interactiveSelector));

    cursor.classList.toggle('is-native', useNative);
    cursor.classList.toggle('is-interactive', isInteractive);
  };

  const render = () => {
    x += (targetX - x) * cursorLerp;
    y += (targetY - y) * cursorLerp;

    if (cursor) {
      cursor.style.transform = `translate3d(${x}px, ${y}px, 0) translate3d(-50%, -50%, 0)`;
    }

    rafId = window.requestAnimationFrame(render);
  };

  const onPointerMove = (event) => {
    targetX = event.clientX;
    targetY = event.clientY;

    if (!hasPointer) {
      hasPointer = true;
      x = targetX;
      y = targetY;
      cursor?.classList.add('is-visible');
    }

    setStateFromTarget(event.target);
  };

  const onPointerOver = (event) => setStateFromTarget(event.target);

  const onPointerLeave = () => {
    hasPointer = false;
    cursor?.classList.remove('is-visible', 'is-interactive', 'is-native');
  };

  const destroy = () => {
    document.documentElement.classList.remove('hex-custom-cursor-ready');
    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerover', onPointerOver);
    document.removeEventListener('pointerleave', onPointerLeave);
    window.removeEventListener('beforeunload', destroy);

    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    cursor?.remove();
    cursor = null;
    window.HEXCursor = undefined;
  };

  const init = () => {
    if (!isSafePage() || cursor) return;

    cursor = document.createElement('div');
    cursor.className = 'hex-custom-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursor);
    document.documentElement.classList.add('hex-custom-cursor-ready');

    document.addEventListener('pointermove', onPointerMove, { passive: true });
    document.addEventListener('pointerover', onPointerOver, { passive: true });
    document.addEventListener('pointerleave', onPointerLeave, { passive: true });
    window.addEventListener('beforeunload', destroy);

    window.HEXCursor = { destroy };
    rafId = window.requestAnimationFrame(render);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
